import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";

interface Prop {
  onClose: () => void;
  id?: number;
}

const FamilyForm: React.FC<Prop> = ({ onClose, id }) => {
  const [formData, setFormData] = useState<any>({ head: "" });
  const [initialFormData, setInitialFormData] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const handleAdd = async () => {
    try {
      const resp = await axiosInstance.post("/api/family", formData);
      if (resp?.status === 200) {
        toast.success("Family created successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || "Failed to create family");
    }
  };

  const handleEdit = async () => {
    try {
      const resp = await axiosInstance.put(`/api/family/${id}`, formData);
      if (resp?.status === 200) {
        toast.success("Family details updated successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || "Failed to update family");
    }
  };
  const handleGetUsers = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/user?search=`);
      if (resp.status === 200) {
        setUserData(resp?.data?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };
  const handleGet = async (id: number) => {
    try {
      const resp: any = await axiosInstance.get(`/api/family/${id}`);
      if (resp.status === 200) {
        setFormData(resp.data.data);
        setInitialFormData(resp.data.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to fetch family");
    }
  };

  const handleChange = (field: string, value: any) => {
    setFormData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!formData?.head) {
      toast.error("Head is required");
      return;
    }

    if (id) {
      const noChanges =
        JSON.stringify(initialFormData) === JSON.stringify(formData);
      if (noChanges) {
        toast.info("No changes were made");
        return;
      }
      await handleEdit();
    } else {
      await handleAdd();
    }
  };

  useEffect(() => {
    if (id) handleGet(id);
    handleGetUsers();
  }, [id]);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {id ? "Edit Family" : "Add Family"}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Head<span style={{ color: "red" }}>*</span>
            </FormLabel>
            <Select
              size="small"
              value={formData?.head ? formData?.head : 0}
              onChange={(e) => handleChange("head", e.target.value)}
            >
              {userData?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12} display={"flex"} justifyContent={"end"}>
          <Box>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default FamilyForm;
